<template>
  <div class="ai">
    <div class="ai-1"></div>
    <div class="ai-2"></div>
    <div class="ai-3"></div>
    <div class="ai-4"></div>
  </div>
</template>
<script>
// import XHR from '../api'
// import Suspend from '../components/Suspend'
export default {
  name: 'Ai1',
  props: [],
  data: () => ({

  }),
  components: {
    // Suspend
  },
  computed: {

  },
  created () {

  },
  mounted () { },
  methods: {

  }
}
</script>

<style lang="less" scoped>
.ai {
  position: relative;
  width: 510px;
  height: 400px;
  transform: scale(0.4);
  .ai-1 {
    position: absolute;
    background: url("https://s.kcimg.cn/topic/images/new-retail/pc-ai1-1.png")
      no-repeat 50% 50%;
    background-size: cover;
    width: 489px;
    height: 268px;
    bottom: 0;
    left: 21px;
  }
  .ai-2 {
    position: absolute;
    top: 16px;
    left: 0;
    background: url("https://s.kcimg.cn/topic/images/new-retail/pc-ai1-2.png")
      no-repeat 50% 50%;
    background-size: cover;
    width: 472px;
    height: 280px;
    animation: ai2 2s infinite ease-in alternate;
  }
  .ai-3 {
    position: absolute;
    top: 57px;
    left: 218px;
    background: url("https://s.kcimg.cn/topic/images/new-retail/pc-ai1-3.png")
      no-repeat 50% 50%;
    background-size: cover;
    width: 178px;
    height: 229px;
    animation: ai3 2s infinite ease-in alternate;
  }
  .ai-4 {
    position: absolute;
    top: 0;
    left: 53px;
    background: url("https://s.kcimg.cn/topic/images/new-retail/pc-ai1-4.png")
      no-repeat 50% 50%;
    background-size: cover;
    width: 278px;
    height: 320px;
    animation: ai1 2s infinite ease-in alternate;
  }
}
@keyframes ai2 {
  from {
    top: 16px;
    opacity: 0.5;
  }
  to {
    top: -10px;
    opacity: 1;
  }
}
@keyframes ai1 {
  from {
    top: -15px;
  }
  to {
    top: 0px;
  }
}
@keyframes ai3 {
  from {
    top: 57px;
  }
  to {
    top: 40px;
  }
}
@media screen and (min-width: 376px) {
  .ai {
    transform: scale(1);
  }
}
</style>
